<template>
  <div style="text-align: center;">
    <p style="margin-top: 15px;">{{ data.message }}</p>
    <div style="text-align: center;">
      <button type="button" @click="closeModal" class="btn btn-fill btn-info">
        Close
      </button>
    </div>
  </div>
</template>

<script>
  export default {
    props: ['data'],
    methods: {
      closeModal () {
        this.$emit('close')
      }
    }
  }
</script>
